// extracted by mini-css-extract-plugin
export default {"referenceValue":"customerJourneyVisualizationReferenceValue_referenceValue__ZOpT7","referenceValueSwitch":"customerJourneyVisualizationReferenceValue_referenceValueSwitch__CUXna"};